// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel .carousel-control-prev,
.carousel .carousel-control-next {
  width: 40px;
  opacity: 0.7;
  filter: invert(0.8);
}

.carousel {
  overflow: visible;
  padding: 0 50px;
  padding-bottom: 30px;
}

.carousel-indicators {
  gap: 8px;
}

.carousel-indicators [data-bs-target] {
  background-color: var(--indicator-unselected);
  width: 25px;
  height: 4px;
  border-radius: 10px;
  border: none;
  opacity: 1;
}

.carousel-indicators .active {
  background-color: var(--primary);
  width: 40px;
  transition: all 0.3s ease;
}

.carousel,
.carousel-inner,
.carousel-item {
  width: 100%;
  min-width: 0;
}

.carousel-item {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  min-width: 0;
}

.carousel-inner {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.unavailable-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  font-size: 1.2rem;
  font-weight: 500;
  border: 1px dashed var(--border);
  border-radius: 8px;
  background: var(--card-bg);
}

@media (max-width: 768px) {
  .carousel {
    padding: 0 30px;
    padding-bottom: 20px;
  }
  .carousel .carousel-control-prev,
  .carousel .carousel-control-next {
    width: 28px;
  }
}

@media (max-width: 480px) {
  .carousel {
    padding: 0 22px;
  }
  .carousel-indicators [data-bs-target] {
    width: 18px;
  }
  .carousel-indicators .active {
    width: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/carousel.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,6CAA6C;EAC7C,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".carousel .carousel-control-prev,\n.carousel .carousel-control-next {\n  width: 40px;\n  opacity: 0.7;\n  filter: invert(0.8);\n}\n\n.carousel {\n  overflow: visible;\n  padding: 0 50px;\n  padding-bottom: 30px;\n}\n\n.carousel-indicators {\n  gap: 8px;\n}\n\n.carousel-indicators [data-bs-target] {\n  background-color: var(--indicator-unselected);\n  width: 25px;\n  height: 4px;\n  border-radius: 10px;\n  border: none;\n  opacity: 1;\n}\n\n.carousel-indicators .active {\n  background-color: var(--primary);\n  width: 40px;\n  transition: all 0.3s ease;\n}\n\n.carousel,\n.carousel-inner,\n.carousel-item {\n  width: 100%;\n  min-width: 0;\n}\n\n.carousel-item {\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.carousel-inner {\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.unavailable-slide {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  font-size: 1.2rem;\n  font-weight: 500;\n  border: 1px dashed var(--border);\n  border-radius: 8px;\n  background: var(--card-bg);\n}\n\n@media (max-width: 768px) {\n  .carousel {\n    padding: 0 30px;\n    padding-bottom: 20px;\n  }\n  .carousel .carousel-control-prev,\n  .carousel .carousel-control-next {\n    width: 28px;\n  }\n}\n\n@media (max-width: 480px) {\n  .carousel {\n    padding: 0 22px;\n  }\n  .carousel-indicators [data-bs-target] {\n    width: 18px;\n  }\n  .carousel-indicators .active {\n    width: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
